import styles from "./report-list-block.module.less";
import ReportList, { TReportingYear } from "../../elements/report-list/report-list";
import SectionHead from "../../elements/section-head/section-head";
import { TLink } from "../../../types/link-types";
import { TTheme } from "../../../types/theme-types";
import { TIndexableBlock } from "../../../types/general-block-types";
import Link from "../../elements/link/link";

export type TReportListBlockProps = {
  heading: string;
  text?: string;
  reportingYears: Array<TReportingYear>;
  disableInvestorCallDate?: boolean;
  link?: TLink;
  theme?: TTheme;
} & TIndexableBlock;

export const ReportListBlock = ({
  heading,
  text,
  reportingYears,
  disableInvestorCallDate,
  link,
  theme,
  index,
}: TReportListBlockProps) => {
  return (
    <section className={[styles.wrapper, theme ? `theme-${theme}` : ""].join(" ")}>
      <div className={`${styles.innerWrapper} max-width padded-sides`}>
        <SectionHead index={index} heading={heading} text={text} />
        <ReportList disableInvestorCallDate={disableInvestorCallDate} reportingYears={reportingYears} />
        {link && (
          <Link
            url={link?.url}
            className={styles.link}
            title={link?.title}
            iconRight={link?.icon ?? "ui-icon-arrow-right"}
          />
        )}
      </div>
    </section>
  );
};

export default ReportListBlock;
